<template>
  <div class="fade-in tasks columns">

    <div class="column is-narrow tasks-sidebar">

      <div class="flex-center">
        <div class="sdgm-back" @click="goBack()">
          <icon class="tiny-svg fill-gray flex" name="arrow-left"></icon>
          <div>{{$t('tasks.backButtonLabel')}}</div>
        </div>
      </div>

      <div class="tasks-phase-wheel-container">
        <phase-wheel class="tasks-phase-wheel"></phase-wheel>
      </div>

      <div class="tasks-result-wheel-title">
        <h5>{{$t('tasks.resultWheelTitle')}}</h5>
      </div>
      <div class="tasks-result-wheel-container">
        <result-wheel class="tasks-result-wheel"></result-wheel>
        <div class="sdgm-center-button-container tasks-result-wheel-button">
          <div class="sdgm-center-button" @click="gotoResult">{{$t('tasks.resultWheelButtonLabel')}}</div>
        </div>
      </div>
    </div>

    <div v-if="!activeGoal" class="tasks-header">
      <h5>{{$t('tasks.noGoals')}}</h5>
    </div>

    <div v-if="activeGoal" class="column tasks-main">
      <div class="tasks-phase-goals">
        <div v-for="goal in activePhaseSelectedGoals" :key="goal.code" @click="selectGoal(goal.code)">
          <icon :name="goal.code" class="tasks-phase-goal" :class="{ 'tasks-phase-goal-selected': goal.code === activeGoal.code }"></icon>
        </div>
      </div>

      <div class="tasks-content flex-1" ref="taskContent">
        <div class="tasks-content-goal">
          <icon class="large-svg sdg-target-icons tasks-content-goal-icon" :name="activeGoal.code"></icon>
          <h1 v-if="profileGoal" :class="['goal-color-' + activeGoal.code]" class="target-color">{{activeGoal.code}}: {{profileGoal.title}}</h1>
        </div>
        <div v-if="profileGoalTargets()" class="tasks-content-targets">
          <div class="tasks-content-targets-list" :class="{ 'tasks-content-targets-list-open': showTargets }">
            <div class="tasks-content-targets-list-item" v-for="target in profileGoalTargets()" :key="target.code">
              <icon class="tasks-content-targets-list-item-bullet" :class="['target-bullet-color-' + activeGoal.code]" name="bullet"></icon>
              <div class="tasks-content-targets-list-item-text">{{target.description}}</div>
            </div>
          </div>
          <div class="tasks-content-targets-toggle">
            <div v-if="!showTargets" class="tasks-content-targets-toggle-button" @click="toggleTargets()">
              <div>{{$t('tasks.buttonLabelShowTargets')}}</div>
              <icon class="tasks-content-targets-toggle-icon" name="arrow-down"></icon>
            </div>
            <div v-else @click="toggleTargets()" class="tasks-content-targets-toggle-button">
              <div>{{$t('tasks.buttonLabelHideTargets')}}</div>
              <icon class="tasks-content-targets-toggle-icon" name="arrow-up"></icon>
            </div>
          </div>
        </div>

        <!-- not editmode -->
        <div v-if="!editMode">
          <div v-if="activeGoal.tasks" class="column is-12 target-list">
            <div v-for="task in notCustomTasks" :key="task.code" class="columns target-row">
              <div class="column is-1" style="min-width: 90px;">
                <icon class="large-svg sdg-target-icons" :class="['task-color-' + activeGoal.code, {'task-selected': task.selected}, {'task-notcustom': !task.custom}]" :task="true" :phaseCode="activePhase.code" :taskCode="task.code" :name="activeGoal.code"></icon>
              </div>
              <div @click="setSelectedTask(task)" class="column is-8 target-input selectable" :class="{'selected': task.selected}">
                <p><b>{{task.title}}</b></p>
                <div v-html="task.description"></div>
              </div>
            </div>

            <div v-for="ctask in customTasks" :key="ctask.code" class="columns target-row">
              <div class="column is-1" style="min-width: 90px;">
                <icon class="large-svg sdg-target-icons" :class="['task-color-' + activeGoal.code, {'task-selected': ctask.custom}]" :task="true" :phaseCode="activePhase.code" :taskCode="ctask.code" :name="activeGoal.code"></icon>
              </div>
              <div v-if="!ctask.edit" class="column is-8 target-input selectable selected-custom">
                <p><b>{{ctask.title}}</b></p>
                <div v-html="ctask.description"></div>
              </div>

              <div v-else class="column is-8 target-input selectable selected-custom" ref="customEditMode">
                <div class="control" style="margin-bottom: 10px;">
                  <input v-model="ctask.title" type="text" class="input" :placeholder="$t('tasks.taskTitlePlaceholder')" ref="customEditTitle" />
                </div>
                <textarea v-model="ctask.description" class="textarea" :placeholder="$t('tasks.taskDescriptionPlaceholder')"></textarea>
              </div>

              <div class="column is-3 flex-column justify-center">
                <a @click="setselectedEditTask(ctask)" class="button task-button" :class="{'active': ctask.edit}">
                  <icon class="small-svg" name="pencil"></icon>
                </a>
                <a @click="openModal('remove-task-modal', ctask)" class="button task-button">
                  <icon class="small-svg" name="bin"></icon>
                </a>
              </div>
            </div>

            <div class="columns target-row">
              <div class="column is-1" style="min-width: 90px;"></div>
              <div @click="createCustomTask()" class="column is-8 target-input new-focusarea selectable">
                <icon class="large-svg" name="add-circle"></icon>
                <p>{{$t('tasks.newFocusArea')}}</p>
              </div>
            </div>

          </div>
        </div>
        <!-- edit mode -->
        <div v-else>
          <div v-if="activeGoal.tasks && activeGoal.tasks.filter(task => task.selected || task.custom).length > 0" class="column is-12 target-list">

            <div v-show="task.selected || task.custom" v-for="task in activeGoal.tasks" :key="task.code" class="columns target-row">
              <div class="column is-1 flex-center" style="min-width: 90px;">
                <icon class="large-svg sdg-target-icons task-selected" :class="['task-color-' + activeGoal.code, {'task-notcustom': !task.custom}]" :task="true" :phaseCode="activePhase.code" :taskCode="task.code" :name="activeGoal.code"></icon>
              </div>
              <div class="column is-11">
                <p><b>{{task.title}}</b></p>
                <div v-html="task.description"></div>
                <div class="columns">
                  <div class="column" style="padding-left: 0px;">
                    <div class="field">
                      <div class="flex-align-center target-input-label write-mode">
                        <!-- <icon class="small-svg fill-primary" name="actions"></icon> -->
                        <label>{{$t('tasks.whatLabel')}}</label>
                      </div>
                      <div class="control">
                        <textarea @blur="setTaskDataChanged()" class="textarea" v-model="task.what" :placeholder="$t('tasks.whatPlaceholder')"></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="column">
                    <div class="field">
                      <div class="flex-align-center target-input-label write-mode">
                        <!-- <icon class="small-svg fill-primary" name="flag"></icon> -->
                        <label>{{$t('tasks.howLabel')}}</label>
                      </div>
                      <div class="control">
                        <textarea @blur="setTaskDataChanged()" class="textarea" v-model="task.how" :placeholder="$t('tasks.howPlaceholder')"></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="column">
                    <div class="flex-align-center target-input-label write-mode">
                      <!-- <icon class="medium-svg fill-primary flex-center" name="effect0"></icon> -->
                      <label>{{$t('tasks.completedPctLabel')}}</label>
                    </div>
                    <div style="padding-top: 27px;">
                      <vue-slider ref="slider" v-model="task.completedPct" @change="setTaskDataChanged()" :class="{'negative-slider': task.negative}" :piecewise="true" :dotSize="20" :min="0" :max="100" :interval="5" :duration="0.5" :height="7" :marks="[0, 25, 50, 75, 100]" tooltip="always" tooltipPlacement="top"></vue-slider>
                      <div style="margin-top: 35px;">
                        <label class="checkbox">
                          <input type="checkbox" v-model="task.negative" @change="setTaskDataChanged()">
                          {{$t('tasks.negativeInfluence')}}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-else class="column is-12 target-list">
            <p class="text-center">{{$t('tasks.noFocusAreas')}}</p>
          </div>
        </div>
      </div>
      <!-- Selected targets -->
      <div class="column is-12 flex-center selected-targets-container" v-if="activeGoal.tasks && activeGoal.tasks.filter(task => task.selected || task.custom).length > 0">
        <button v-if="!editMode" class="targets-button selected-targets-button" :class="{'bounceIn': !editMode}" @click="editMode = true, setScroll()">
          {{$t('tasks.selectedTargetsButton')}}
        </button>
        <button v-else class="targets-button all-targets-button" @click="editMode = false, setScroll()">
          {{$t('tasks.allTargetsButton')}}
        </button>
        <div class="selected-targets-counter">
          <span>
            {{activeGoal.tasks.filter(task => task.selected || task.custom).length}}
          </span>
          <span>
            {{$t('tasks.tasksLabel')}}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import vueSlider from 'vue-slider-component'
import phaseWheel from './../shared/phase-wheel/phase-wheel'
import resultWheel from './../shared/result-wheel/result-wheel.vue'

export default {
  name: 'tasks',
  components: {
    phaseWheel,
    resultWheel,
    vueSlider
  },
  data () {
    return {
      showTargets: false,
      targets: [],
      editMode: false
    }
  },
  computed: {
    ...mapGetters({
      profile: 'getProfile',
      activeGoal: 'getActiveGoal',
      activePhase: 'getActivePhase',
      activeGoalCode: 'getActiveGoalCode',
      profileGoal: 'getActiveProfileGoal',
      activePageCode: 'getActivePageCode',
      activePhaseIndex: 'getActivePhaseIndex',
      profileGoalTargets: 'getProfileGoalTargets',
      activePhaseSelectedGoals: 'getActivePhaseSelectedGoals'
    }),
    notCustomTasks () {
      return this.activeGoal.tasks.filter(task => !task.custom)
    },
    customTasks () {
      return this.activeGoal.tasks.filter(task => task.custom)
    }
  },
  methods: {
    ...mapActions({
      setShowModal: 'setShowModal',
      setModalType: 'setModalType',
      setModalData: 'setModalData',
      addCustomTask: 'addCustomTask',
      setActivePageCode: 'setActivePageCode',
      setActiveGoalCode: 'setActiveGoalCode',
      setTaskDataChanged: 'setTaskDataChanged',
      resetAllEditTasksAction: 'resetAllEditTasksAction'
    }),
    goBack () {
      this.setActivePageCode('goals')
    },
    selectGoal (goalCode) {
      this.setActiveGoalCode(goalCode)
      this.$refs.taskContent.scrollTo(0, 0)
    },
    toggleTargets () {
      this.showTargets = !this.showTargets
      if (this.showTargets) {

      }
    },
    gotoResult () {
      this.setActivePageCode('results')
    },
    setSelectedTask (task) {
      if (!task.custom) {
        this.setTaskDataChanged()
        // this.setScroll()
        task.selected = !task.selected
      }
    },
    setselectedEditTask (taskItem) {
      this.activeGoal.tasks.filter(task => task.custom).forEach(task => {
        if (task.code === taskItem.code) {
          task.edit = !task.edit
          if (task.edit) {
            this.$nextTick(() => {
              if (Element.prototype.scrollIntoViewIfNeeded) {
                if (this.$refs.customEditMode) {
                  this.$refs.customEditTitle[0].focus()
                  this.$refs.customEditMode[0].scrollIntoViewIfNeeded()
                }
              }
            })
          }
        } else {
          task.edit = false
        }
      })
    },
    setScroll () {
      this.$nextTick(() => {
        this.$refs.taskContent.scrollTop = 0
      })
    },
    openModal (type, data) {
      this.setShowModal(true)
      this.setModalType(type)
      this.setModalData(data)
    },
    setDefaultGoal () {
      let selectedGoals = this.activePhaseSelectedGoals
      if (selectedGoals.length > 0) {
        this.setActiveGoalCode(selectedGoals[0].code)
      } else {
        this.setActiveGoalCode(false)
      }
    },
    editTasks () {
      this.editMode = !this.editMode
    },
    createCustomTask () {
      this.addCustomTask()
      this.setTaskDataChanged()
      this.$nextTick(() => {
        if (Element.prototype.scrollIntoViewIfNeeded) {
          if (this.$refs.customEditMode) {
            this.$refs.customEditMode[0].scrollIntoViewIfNeeded()
            this.$refs.customEditTitle[0].focus()
          }
        }
      })
    }
  },
  watch: {
    activePhaseIndex () {
      this.editMode = false
      this.setDefaultGoal()
      if (this.$refs.taskContent) {
        this.$refs.taskContent.scrollTo(0, 0)
      }
    },
    activeGoalCode () {
      this.editMode = false
    },
    editMode (val) {
      if (val) {
        this.resetAllEditTasksAction()
      }
    }
  },
  mounted () {
    this.setDefaultGoal()
  }
}
</script>
